import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['DOCUMENTATION_END_POINT']}`

const DocumentationHttp = {
  getDocumentation(number) {
    const url = BASE_URL + `/doc/portal/${number}`
    return url
  },
}

export default DocumentationHttp
